import { inject, Injectable } from '@angular/core';
import { combineLatest, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '@app/services';
import { NavigationTabBarItemSchema } from '@app/schemas/navigation';
import { PageSchema } from '@app/schemas/page';
import { PageService } from '@app/services/page';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {

  private readonly configService = inject(ConfigService);
  private readonly pageService = inject(PageService);

  public readonly config$ = combineLatest([
    this.configService.config$.pipe(
      map(({ navigation }) => navigation),
    ),
    this.pageService.config$,
  ]).pipe(
    map(([navigation, pages]) => {
      return {
        ...navigation,
        tabBar: {
          ...navigation.tabBar,
          items: this.filterAvailableNavigationTabBarItemsByAvailablePages(
            navigation.tabBar.items,
            pages,
          ),
        },
      };
    }),
    shareReplay(1),
  );

  public filterAvailableNavigationTabBarItemsByAvailablePages(
    tabs: NavigationTabBarItemSchema[],
    pages: PageSchema[],
  ): NavigationTabBarItemSchema[] {
    return tabs.filter((item) => {
      if (item.type === 'image') {
        return true;
      }

      if (item.action.type === 'page') {
        return !!this.pageService.findPageById(pages, item.action.pageId);
      }

      return true;
    });
  }

}
